<template>
  <footer class="footer">
    <div class="footerButton">
      <h3>無料でお試し・資料請求</h3>
      <div class="buttons">
       <nuxt-link class="button trial" to="/auth/register">無料お試し</nuxt-link>
        <nuxt-link class="button download" to="/resources">資料をダウンロード</nuxt-link>
      </div>
    </div>
    <div class="footerLink">
      <img class="" src="/frontend/img/logo-c.svg" alt="モチカケ">
      <div class="links">
        <div class="line">
          <nuxt-link to="/trade" class="">特定商取引法に基づく表記</nuxt-link>
          <nuxt-link target="_blank" to="/terms" class="">利用規約</nuxt-link>
          <nuxt-link target="_blank" to="/privacy" class="">プライバシーポリシー</nuxt-link>
          <a href="https://sample-text.co.jp/" target="_blank" class="">運営会社<i class="las la-external-link-alt"></i></a>
        </div>
        <div class="line">
          <nuxt-link to="/contact" class="">お問い合わせ</nuxt-link>
          <a href="https://intercom.help/admin-legalscript/ja" target="_blank" class="">ヘルプ<i class="las la-external-link-alt"></i></a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'f-footer-lp'
}
</script>
